export const SET_FILTER_DETAILS = "SET_FILTER_DETAILS";
export const GET_FILTER_DETAILS = "GET_FILTER_DETAILS";
export const CLEAR_FILTER_DETAILS = "CLEAR_FILTER_DETAILS";
